import { D37 } from "./CustomerGroupSales/D37";
import { D37_02 } from "./ProductSales/D37_02";
import { D36 } from "./ProductSalesPerf/D36";
import { D39 } from "./PMR/D39";

export const DistrictCustomerGroupProduct = {
  "sections": [
    D37,
    D37_02,
    D36,
    D39
  ]
}